/* sunbasker: Opposite-leg contact at the half-cycle; tail keeps its returning sweep.
 * Eight authored 16x16 poses; palette and gameplay bounds are unchanged. */

export const sunbasker_0 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '...ooooooooo.e..',
  'C.oocCcCcCcooco.',
  '.o.oosssosso....',
  '...o..oo..o.....',
  '.......o...o....',
  '................',
  '................',
  '................',
  '................',
];

export const sunbasker_1 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '...ooooooooo.e..',
  '...ocCcCcCcooco.',
  'C.ooosssosso....',
  '.o.o..oo..o.....',
  '.......o...o....',
  '................',
  '................',
  '................',
  '................',
];

export const sunbasker_2 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '...ooooooooo.e..',
  '...ocCcCcCcooco.',
  '...ossosssoo....',
  'C.o.o..oo..o....',
  '.o.o...o........',
  '................',
  '................',
  '................',
  '................',
];

export const sunbasker_3 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '...ooooooooo.e..',
  '...ocCcCcCcooco.',
  'C.oossosssoo....',
  '.o..o..oo..o....',
  '...o...o........',
  '................',
  '................',
  '................',
  '................',
];

export const sunbasker_4 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '...ooooooooo.e..',
  'C.oocCcCcCcooco.',
  '...ossosssoo....',
  '....o..oo..o....',
  '...o...o........',
  '................',
  '................',
  '................',
  '................',
];

export const sunbasker_5 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '.o..............',
  'C.oooooooooo.e..',
  '...ocCcCcCcooco.',
  '...oosssosso....',
  '...o..oo..o.....',
  '.......o...o....',
  '................',
  '................',
  '................',
  '................',
];

export const sunbasker_6 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '.o..............',
  'C.o.............',
  '...ooooooooo.e..',
  '...ocCcCcCcooco.',
  '...ossosssoo....',
  '....o..oo..o....',
  '...o...o........',
  '................',
  '................',
  '................',
  '................',
];

export const sunbasker_7 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '................',
  '.o..............',
  'C.oooooooooo.e..',
  '...ocCcCcCcooco.',
  '...ossosssoo....',
  '....o..oo..o....',
  '...o...o........',
  '................',
  '................',
  '................',
  '................',
];
